import { paymentRepository } from '../repositories/payment-repository';

async function getPayments() {
    return paymentRepository.getAll();
}

export {
    getPayments
};
